<div class="popup-dialog">
    <div
        class="trezo-card w-100 border-radius d-block bg-white border-0 shadow-none"
    >
        <div
            class="trezo-card-header d-flex align-items-center justify-content-between"
        >
            <div class="trezo-card-title">
                <h5 class="mb-0">
                    {{ titleText }}
                </h5>
            </div>
            <div class="trezo-card-subtitle">
                <button
                    (click)="toggleClass()"
                    class="p-0 border-0 lh-1 bg-transparent transition"
                >
                    <i class="ri-close-fill"></i>
                </button>
            </div>
        </div>
        <form [formGroup]="frmGroup" (ngSubmit)="onSave()">
            <div class="trezo-card-content">
                <div class="row v-scroll">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                                class="main-label d-block fw-medium text-black"
                            >
                                AddressLine1 <span class="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="AddressLine1"
                                formControlName="addressLine1Control"
                                maxlength="200"
                            />
                            <div
                                class="form-text text-danger"
                                *ngIf="
                                    isSubmitted &&
                                    f['addressLine1Control']!.hasError(
                                        'required'
                                    )
                                "
                            >
                                AddressLine1 is required.
                            </div>
                            <div
                                class="form-text text-danger"
                                *ngIf="
                                    isSubmitted &&
                                    f['addressLine1Control']!.hasError(
                                        'onlyWhitespace'
                                    )
                                "
                            >
                                AddressLine1 can not be only whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                                class="main-label d-block fw-medium text-black"
                            >
                                AddressLine2
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="AddressLine2"
                                formControlName="addressLine2Control"
                                maxlength="200"
                            />
                            <div
                                class="form-text text-danger"
                                *ngIf="
                                    isSubmitted &&
                                    f['addressLine2Control']!.hasError(
                                        'onlyWhitespace'
                                    )
                                "
                            >
                                AddressLine2 can not be only whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                                class="main-label d-block fw-medium text-black"
                            >
                                Landmark
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Landmark"
                                formControlName="landmarkControl"
                                maxlength="200"
                            />
                            <div
                                class="form-text text-danger"
                                *ngIf="
                                    isSubmitted &&
                                    f['landmarkControl']!.hasError(
                                        'onlyWhitespace'
                                    )
                                "
                            >
                                Landmark can not be only whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                                class="main-label d-block fw-medium text-black"
                            >
                                Pincode
                                <span class="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Pin code"
                                formControlName="pinCodeControl"
                                maxlength="6"
                            />
                            <div
                                class="form-text text-danger"
                                *ngIf="
                                    isSubmitted &&
                                    f['pinCodeControl']!.hasError('required')
                                "
                            >
                                Pincode is required.
                            </div>
                            <div
                                class="form-text text-danger"
                                *ngIf="
                                    isSubmitted &&
                                    f['pinCodeControl']!.hasError(
                                        'onlyWhitespace'
                                    )
                                "
                            >
                                Pincode can not be only whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                                class="main-label d-block fw-medium text-black"
                            >
                                Country Name <span class="text-danger">*</span>
                            </label>
                            <select
                                class="form-select"
                                formControlName="countryControl"
                                [compareWith]="countryComparer"
                                (change)="
                                    onCountryChange(f['countryControl'].value)
                                "
                                [ngClass]="{
                                    'is-invalid':
                                        isSubmitted &&
                                        f['countryControl']!.hasError(
                                            'required'
                                        )
                                }"
                            >
                                <option [ngValue]="null" disabled>
                                    Please Select
                                </option>
                                <option
                                    *ngFor="let c of country$ | async"
                                    [ngValue]="c"
                                >
                                    {{ c.name }}
                                </option>
                            </select>
                            <div
                                class="form-text text-danger"
                                *ngIf="
                                    isSubmitted &&
                                    f['countryControl']!.hasError('required')
                                "
                            >
                                Country Name is required.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                                class="main-label d-block fw-medium text-black"
                            >
                                State Name <span class="text-danger">*</span>
                            </label>
                            <select
                                class="form-select"
                                formControlName="stateControl"
                                [compareWith]="stateComparer"
                                (change)="
                                    onStateChange(f['stateControl'].value)
                                "
                                [ngClass]="{
                                    'is-invalid':
                                        isSubmitted &&
                                        f['stateControl']!.hasError('required')
                                }"
                            >
                                <option [ngValue]="null" disabled>
                                    Please Select
                                </option>
                                <option *ngFor="let c of state" [ngValue]="c">
                                    {{ c.name }}
                                </option>
                            </select>
                            <div
                                class="form-text text-danger"
                                *ngIf="
                                    isSubmitted &&
                                    f['stateControl']!.hasError('required')
                                "
                            >
                                State Name is required.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                                class="main-label d-block fw-medium text-black"
                            >
                                City Name <span class="text-danger">*</span>
                            </label>
                            <select
                                class="form-select"
                                formControlName="cityControl"
                                [compareWith]="cityComparer"
                                [ngClass]="{
                                    'is-invalid':
                                        isSubmitted &&
                                        f['cityControl']!.hasError('required')
                                }"
                            >
                                <option [ngValue]="null" disabled>
                                    Please Select
                                </option>
                                <option *ngFor="let c of city" [ngValue]="c">
                                    {{ c.name }}
                                </option>
                            </select>
                            <div
                                class="form-text text-danger"
                                *ngIf="
                                    isSubmitted &&
                                    f['cityControl']!.hasError('required')
                                "
                            >
                                City Name is required.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <button
                        type="button"
                        (click)="toggleClass()"
                        class="warn d-inline-block fw-medium border-0 border-radius transition"
                    >
                        Cancel
                    </button>
                    <button
                        class="primary d-inline-block fw-medium border-0 border-radius transition"
                        [disabled]="!formIsValid() || !dataHasChanged()"
                    >
                        <span class="position-relative d-inline-block">
                            <i class="material-symbols-outlined"> add </i>
                            {{ titleButton }}
                        </span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
